/**
 * Web.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ApplicationTurnOversGetTurnOverBySalesRepresentativeResponse { 
    salesRepresentativeId?: string | null;
    salesRepresentativeName?: string | null;
    amount?: number;
    userId?: string;
    employerColor?: string | null;
    employerName?: string | null;
}

